module.exports = __webpack_public_path__ + "static/media/telebike.39eb9e5a.png";